import { render, staticRenderFns } from "./FulfillmentInventory.vue?vue&type=template&id=76245365"
import script from "./FulfillmentInventory.vue?vue&type=script&lang=js"
export * from "./FulfillmentInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports